export enum scoutAlertTypes {
  FETCH_SCOUT_ALERT_REQUEST = "FETCH_SCOUT_ALERT_REQUEST",
  FETCH_SCOUT_ALERT_SUCCESS = "FETCH_SCOUT_ALERT_SUCCESS",
  FETCH_SCOUT_ALERT_FAILURE = "FETCH_SCOUT_ALERT_FAILURE",
}